module.exports = __webpack_public_path__ + "static/img/bc-sxcq.84b7119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-sxcq.png
// module id = 2FDW
// module chunks = 0